import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon, TargetIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { CHECKOUT_LINKS } from '../data/checkout';
import { packIncluded, upsellIncluded, upsellComparison, upsellModules } from '../data/upsell';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-navy-900" data-id="element-204" data-mp="2jk5z539mrzpp">
      <div className="container mx-auto px-4" data-id="element-205" data-mp="1vtiav7feqxgz">
        <div className="text-center mb-16" data-id="element-206" data-mp="1vubmomt84d5z">
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[28px]" data-id="element-207" data-mp="1rsq20fag6ul8">
            🛒 ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-silver text-[16px]" data-id="element-208" data-mp="25t9afnits2nx">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-10" data-id="element-209" data-mp="20rtlvlhfve0s">
          {/* Opción 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-navy-950 rounded-3xl p-8 shadow-2xl border border-silver/20 flex flex-col h-full relative z-10" data-id="element-210" data-mp="3h97ns3l1dauy">
            <div className="mb-6" data-id="element-211" data-mp="9qe69kmdpq2z">
              <p className="text-silver-dark font-bold uppercase tracking-wider text-sm mb-2" data-id="element-212" data-mp="erv4t9he50ge">
                OPCIÓN 1
              </p>
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-213" data-mp="3daikvph7x8kk">
                🔍 MEGAPACK CRIMINALÍSTICA LISTO™
              </h3>
              <p className="text-silver-dark font-medium" data-id="element-214" data-mp="3n6lo6ynt3d93">6 Tomos + 4 Bonos</p>
            </div>

            <div className="mb-6 pb-6 border-b border-silver/15" data-id="element-215" data-mp="3rydfjbesdn0a"></div>

            <div className="mb-8" data-id="element-216" data-mp="2uihd1xmgu7z0">
              <div className="flex items-end gap-2" data-id="element-217" data-mp="2uj98n8g2c5pa">
                <span className="text-5xl font-black text-white" data-id="element-218" data-mp="2ugn29c4wrw8n">$19.990</span>
                <span className="text-xl font-bold text-silver-dark mb-1" data-id="element-219" data-mp="2zfpxy5z00q3y">
                  ARS
                </span>
              </div>
              <p className="text-silver-dark line-through mt-1" data-id="element-220" data-mp="2mi1l7ianzzbz">$72.000 ARS</p>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-221" data-mp="316ekop8yo0b8">
              {packIncluded.map(item => <li key={item} className="flex items-start gap-3" data-id="element-222" data-mp="2w7uxymmjmkht">
                  <CheckIcon className="w-5 h-5 text-silver-dark shrink-0 mt-0.5" data-id="element-223" data-mp="2w9o666ct1crx" />
                  <span className="text-silver text-sm" data-id="element-224" data-mp="28iiodlnb0aez">
                    {item.replace(/^[✅🎁]\s/, '')}
                  </span>
                </li>)}
            </ul>

            <a href={CHECKOUT_LINKS.megapack} target="_blank" rel="noopener noreferrer" className="block" data-id="element-225" data-mp="2igy7p2g3afdx">
              <Button variant="outline" size="lg" fullWidth data-id="element-226" data-mp="3tuk6lfbr3vcn">
                🔥 QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Opción 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-navy-950 rounded-3xl p-8 shadow-2xl border-2 border-silver flex flex-col h-full relative z-10 transform lg:-translate-y-4" data-id="element-227" data-mp="9uce0beghhn">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-silver text-navy-950 font-black px-4 py-1 rounded-full text-sm uppercase tracking-wider flex items-center gap-1 shadow-lg whitespace-nowrap" data-id="element-228" data-mp="nzoo2ejzg00b">
              <StarIcon className="w-4 h-4 fill-navy-950" data-id="element-229" data-mp="e93kecpgc5aj" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-230" data-mp="11zhes9vieg8a">
              <p className="text-silver-dark font-bold uppercase tracking-wider text-sm mb-2" data-id="element-231" data-mp="11xmpykh4a3yx">
                OPCIÓN 2
              </p>
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-232" data-mp="3f81r6sdm8ymr">
                🔍 MEGAPACK CRIMINALÍSTICA LISTO™ + UPSELL PREMIUM
              </h3>
              <p className="text-silver-light font-bold" data-id="element-233" data-mp="359cjttjciwkr">
                6 Tomos + 4 Bonos + 2 Módulos Avanzados
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-silver/25" data-id="element-234" data-mp="3192emj3doa6y"></div>

            <div className="mb-8" data-id="element-235" data-mp="1t5elila8r9v">
              <div className="flex items-end gap-2" data-id="element-236" data-mp="1s43xf86i6so">
                <span className="text-5xl font-black text-white" data-id="element-237" data-mp="3sz6xuefeir6l">$27.990</span>
                <span className="text-xl font-bold text-silver mb-1" data-id="element-238" data-mp="3t19lirt30885">ARS</span>
              </div>
              <p className="text-silver-dark line-through mt-1" data-id="element-239" data-mp="3o5u9m5emwmed">$110.000 ARS</p>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-240" data-mp="3k4sh07f838ld">
              {packIncluded.map(item => <li key={item} className="flex items-start gap-3" data-id="element-241" data-mp="kkybvp7dwyne">
                  <CheckIcon className="w-5 h-5 text-silver shrink-0 mt-0.5" data-id="element-242" data-mp="fqu3d1ih0ik7" />
                  <span className="text-silver text-sm" data-id="element-243" data-mp="1yg6m39u8omuz">
                    {item.replace(/^[✅🎁]\s/, '')}
                  </span>
                </li>)}
              {upsellIncluded.map(item => <li key={item} className="flex items-start gap-3" data-id="element-244" data-mp="27e9xveffa59l">
                  <CheckIcon className="w-5 h-5 text-silver-light shrink-0 mt-0.5" data-id="element-245" data-mp="2cf6b4ilnz3ro" />
                  <span className="text-silver-light text-sm font-bold" data-id="element-246" data-mp="2he995j3889q5">
                    {item.replace(/^🚀\s/, '')}
                  </span>
                </li>)}
            </ul>

            <a href={CHECKOUT_LINKS.upsell} target="_blank" rel="noopener noreferrer" className="block" data-id="element-247" data-mp="2r42e418v5qlf">
              <Button variant="primary" size="lg" fullWidth data-id="element-248" data-mp="2v78it4gbv9ps">
                ⚡ QUIERO EL MEGAPACK + UPSELL PREMIUM
              </Button>
            </a>
          </motion.div>
        </div>

        <p className="text-center text-silver-dark text-sm mb-20" data-id="element-249" data-mp="351hchvh3h8pj">
          Podés pagar con tarjeta de crédito o débito, transferencia bancaria o
          Mercado Pago en pesos argentinos.
        </p>

        {/* Upsell details */}
        <div className="max-w-4xl mx-auto" data-id="element-250" data-mp="1erni4yhzhiob">
          <div className="text-center mb-10" data-id="element-251" data-mp="1esq730vqxb1l">
            <h3 className="text-2xl md:text-3xl font-extrabold text-white flex items-center justify-center gap-2" data-id="element-252" data-mp="1a0oyboxse2gb">
              <TargetIcon className="w-8 h-8 text-silver" data-id="element-253" data-mp="1nr27tvqbtp7r" />
              ¿QUÉ AGREGA EL UPSELL PREMIUM?
            </h3>
          </div>

          <p className="text-center text-xs text-silver-dark mb-2 md:hidden" data-id="element-254" data-mp="1jpp3xr6snw3h">
            ← Deslizá para ver la tabla completa →
          </p>
          <div className="overflow-x-auto pb-4 mb-12" data-id="element-255" data-mp="1sr6dsrtlz1jq">
            <div className="min-w-[700px]" data-id="element-256" data-mp="1srpwiar31tyt">
              <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-257" data-mp="3bqes59eew7k">
                <div className="font-bold text-silver-dark uppercase text-sm tracking-wider" data-id="element-258" data-mp="3e2wqif5p6km">
                  Situación
                </div>
                <div className="font-bold text-silver-dark uppercase text-sm tracking-wider" data-id="element-259" data-mp="29zpie9s98z14">
                  ❌ Sin Upsell Premium
                </div>
                <div className="font-bold text-silver-light uppercase text-sm tracking-wider" data-id="element-260" data-mp="2f1er3is090m1">
                  ✅ Con Upsell Premium
                </div>
              </div>

              <div className="space-y-2" data-id="element-261" data-mp="257xygi3ltrjy">
                {upsellComparison.map(row => <div key={row.sit} className="grid grid-cols-3 gap-4 bg-navy-950/70 rounded-xl p-4 items-center border border-silver/15" data-id="element-262" data-mp="1r8ycji7h7qrh">
                    <div className="text-silver font-medium text-sm" data-id="element-263" data-mp="1hcv6w2df19zs">
                      {row.sit}
                    </div>
                    <div className="text-silver-dark text-sm" data-id="element-264" data-mp="1mcr49irly36d">{row.sin}</div>
                    <div className="text-silver-light font-medium text-sm" data-id="element-265" data-mp="3bq48z93mtt80">
                      {row.con}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="text-center mb-10" data-id="element-266" data-mp="24h5athh99mr6">
            <h3 className="text-2xl md:text-3xl font-extrabold text-white" data-id="element-267" data-mp="1zhaj5bpnot52">
              🚀 ¿QUÉ INCLUYE EL UPSELL PREMIUM?
            </h3>
          </div>

          <div className="space-y-8" data-id="element-268" data-mp="1un6eiz3v4x75">
            {upsellModules.map(mod => <div key={mod.title} className="bg-navy-800/50 rounded-2xl p-6 md:p-8 border border-silver/20" data-id="element-269" data-mp="1pobvpx5wb8n1">
                <h4 className="font-bold text-silver-light mb-6 uppercase tracking-wider" data-id="element-270" data-mp="1gooqt1dyjkp8">
                  {mod.title}
                </h4>
                <div className="space-y-6" data-id="element-271" data-mp="1bsrc0zicemek">
                  {mod.items.map(item => <div key={item.title} data-id="element-272" data-mp="16tesanmrpvg7">
                      <p className="font-bold text-white mb-1" data-id="element-273" data-mp="3657qgnlal6ui">{item.title}</p>
                      <p className="text-silver text-sm" data-id="element-274" data-mp="315lcgbxn3mkn">{item.desc}</p>
                    </div>)}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}